import React, { Component } from "react"
import styled from "styled-components"

import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"

const SectionBlockContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 3;
  width: ${props => (props.bigIllustration ? "30%" : "50%")};
  margin: 0 50px;
  margin-top: 50px;

  @media (max-width: 900px) {
    margin-right: 0px;
  }

  @media (max-width: 768px) {
    text-align: center;
    margin-top: -50px;
    margin: 0px;
    width: 70%;
  }

  @media (max-width: 480px) {
    text-align: center;
    margin: 0px;
    width: 95%;
  }
`
const SectionBlockHeadline = styled.h2`
  margin-bottom: 20px;

  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`

const SectionBlockCopy = styled.p`
  margin-bottom: 20px;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`

const SectionBlockProTip = styled.p`
  color: ${SECONDARY_TEXT};
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`

const SectionBlockCTA = styled.a`
  color: ${ACTIVE_TEXT};
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`

const SectionBlockContent = props => (
  <SectionBlockContentWrapper bigIllustration={props.bigIllustration}>
    <SectionBlockHeadline>{props.headline}</SectionBlockHeadline>
    <SectionBlockCopy>{props.copy}</SectionBlockCopy>
    <SectionBlockProTip>{props.protips}</SectionBlockProTip>
    <SectionBlockCTA href={props.link}>{props.linkText}</SectionBlockCTA>
  </SectionBlockContentWrapper>
)

export default ({
  bigIllustration,
  headline,
  copy,
  protips,
  link,
  linkText
}) => (
  <SectionBlockContent
    bigIllustration={bigIllustration}
    headline={headline}
    copy={copy}
    protips={protips}
    link={link}
    linkText={linkText}
  />
)



// WEBPACK FOOTER //
// ./src/components/SectionBlockContent.js